/**
 * Professionals helper to convert objects (including nested arrays and objects) 
 * into a flattened FormData structure that backends can parse.
 * 
 * Example:
 * { user: { name: 'John' } } -> formData.append('user[name]', 'John')
 */
export const appendToFormData = (
    formData: FormData,
    data: any,
    parentKey?: string
) => {
    if (Array.isArray(data) && data.length === 0) {
        if (parentKey) {
            formData.append(parentKey, "");
        }
    } else if (
        data &&
        typeof data === "object" &&
        !(data instanceof Date) &&
        !(data instanceof File) &&
        !(data instanceof Blob)
    ) {
        Object.keys(data).forEach((key) => {
            const fullKey = parentKey ? `${parentKey}[${key}]` : key;
            appendToFormData(formData, data[key], fullKey);
        });
    } else {
        // Handle null/undefined values by sending empty string or skipping
        // Generally, backends prefer empty strings or simply not sending the key.
        // We'll send empty string for consistency if the key exists.
        const value = data === null || data === undefined ? "" : data;

        // If we have a key, append the value
        if (parentKey) {
            formData.append(parentKey, value);
        }
    }
};
